module.exports = __webpack_public_path__ + "assets/img/customerService-b01d64df.png";